<template>
  <div class="home-page">
    <Header :title="title"></Header>
    <div class="nav">
      <div @click="handle(1)">
        <img src="@/assets/images/calendar.png"
             alt="calendar_icon">
        <span>打卡日历</span>
      </div>
      <div @click="handle(2)">
        <img src="@/assets/images/icon_record@2x.png"
             alt="myrank_icon">
        <span>打卡记录</span>
      </div>
      <div @click="handle(3)">
        <img src="@/assets/images/rank@2x.png"
             alt="calendar_icon">
        <span>排行榜</span>
      </div>
    </div>
    <div class="lines"></div>
    <div class="detail">
      <div class="detail_title">
        <span>今日打卡</span>
        <span class="goCheckIn"
              v-if="detail.join_status && this.daily_id > 0"
              @click="goExam(detail)"
              :class="detail.status==3?'end':''">{{getCardStatus(detail)}}</span>
      </div>
      <CheckInInfo :join_user="detail.join_user"></CheckInInfo>
      <div class="description">
        <span>活动介绍：</span>
        {{detail.description}}
      </div>
    </div>
    <div class="join"
         v-if="detail.join_status==0"
         @click="join">加入打卡</div>
  </div>
</template>
<script>
import Header from "@/components/Header";
import List from "@/components/List";
import CheckInItem from "@/components/checkIn/CheckInItem";
import CheckInInfo from "@/components/checkIn/CheckInInfo";
export default {
  name: "myCheckIn",
  components: {
    List,
    Header,
    CheckInItem,
    CheckInInfo
  },
  data () {
    return {
      title: {
        name: "打卡主页"
      },
      id: null,
      daily_id: 0,
      detail: {}
    };
  },
  async created () {
    this.id = this.$route.query.id;
    await this.getDetail();
    await this.getTodayCheckinId();
  },
  methods: {
    getDetail () {
      this.$http.get(`/api/app/checkin/${this.id}`).then((res) => {
        this.detail = res;
      });
    },
    getCardStatus (detail) {
      if (detail.status == 2 && this.daily_id > 0) {//打卡活动状态 1:未开始 2:进行中 3:已结束
        if (detail.today_status == 0) { //今日是否打卡 1: 已打卡 0: 未打卡
          return '去打卡';
        } else {
          return '查看报告';
        }
      } else if (detail.status == 1) {
        return '活动未开始';
      } else if (detail.status == 3) {
        return '活动已结束';
      }
    },
    join () {
      this.$http.post(`/api/app/checkin/join/${this.detail.id}`).then((res) => {
        this.$toast('加入打卡成功');
        this.getDetail();
      });
    },
    goExam (detail) {
      if (detail.status == 1) {
        this.$toast('活动未开始');
      } else if (detail.status == 2) {
        if (detail.today_status) {//今日已打卡，跳转答题报告
            this.$router.replace({
              name: "Result",
              query: {
                id: detail.report_id,
                paper_id: this.daily_id,
                type: 'CheckIn',
                number: 0
              }
            });
        } else{//今日未打卡，跳转做题页
          if (this.daily_id > 0) {
            //获取今日打卡的id
            this.$router.push({ name: 'ExerciseQueston', query: { type: 'CheckIn', id: this.daily_id } });
          } else {
            this.$router.push({ name: 'CheckInCalendar', query: { id: this.$route.query.id } });
          }
        }
      } else if (detail.status == 3) {
        this.$toast('活动已结束');
      }
    },
    isGoDetail () {
      if (this.detail.status == 1) {
        this.$toast('活动暂未开始');
      }
      // else if (this.detail.status == 3) {
      //   this.$toast('活动已结束');
      // }
      else {
        if (this.detail.join_status != 1) {
          this.$toast('请先加入打卡活动')
        } else {
          return true;
        }
      }
    },
    handle (flag) {
      if (this.isGoDetail()) {
        if (flag == 1) {
          this.$router.push({ name: 'CheckInCalendar', query: { id: this.detail.id } })
        } else if (flag == 2) {
          this.$router.push({ name: 'RecordCheckIn', query: { id: this.detail.id } })
        } else {
          this.$router.push({ name: 'Rank', query: { id: this.detail.id } })
        }
      }
    },
    getTodayCheckinId () {
      this.$http.get(`/api/app/checkin/daily/today/${this.id}`).then((res) => {
        this.daily_id = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100vh;
  background: #ffffff;
  font-size: 24px;
  font-family: PingFang SC;
  /deep/ {
    .header {
      border-bottom: 1px solid #f6f6f6;
    }
  }
  .nav {
    height: 240px;
    display: flex;
    padding: 0 97px;
    justify-content: space-between;
    align-items: center;
    div {
      text-align: center;
    }
    img {
      display: block;
      width: 97px;
      height: 97px;
    }
    span {
      display: block;
      color: #666666;
      margin-top: 20px;
    }
  }
  .lines {
    height: 30px;
    background-color: #f6f6f6;
  }
  .detail {
    padding: 0 30px;
    .detail_title {
      font-size: 32px;
      color: #333;
      font-weight: 500;
      height: 110px;
      line-height: 110px;
      .goCheckIn {
        text-align: center;
        float: right;
        color: #fff;
        padding: 0 12px;
        height: 46px;
        font-size: 24px;
        line-height: 46px;
        background-color: $theme_color;
        margin-top: 30px;
        border-radius: 4px;
      }
      .end {
        background-color: #999999;
      }
    }
    .description {
      margin-top: 45px;
      color: #666666;
      font-size: 24px;
      line-height: 36px;
      span {
        color: #333333;
        font-weight: 500;
      }
    }
  }
  .join {
    background-color: $theme_color;
    color: #fff;
    height: 100px;
    line-height: 100px;
    font-size: 32px;
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}
</style>
